import React from 'react'
import { Form, Field, reduxForm } from 'redux-form'
import RenderFormField from 'components/render-form-field'
import { requiredField, validEmail } from 'util/field-validation'
import striptags from 'striptags'

import CancelableSumbitButton from 'components/buttons/cancelable-submit-button'

const RecoverPasswordForm = ({ submitting, loading, error, handleSubmit }) => {
  const buttonsDisabled = submitting || loading

  const formError = error ? (
    <div
      className='form--error'
      data-ext='form--error-recover-password'
      dangerouslySetInnerHTML={{ __html: striptags(error, ['a']) }}
    />
  ) : null

  return (
    <Form
      id='ext--recover-password-form'
      data-test-key='recover-password-form'
      className='form'
      method='POST'
      noValidate='novalidate'
      onSubmit={handleSubmit}
    >
      <Field
        name='email'
        placeholder='Email address'
        component={RenderFormField}
        type='email'
        validate={[requiredField, validEmail]}
      />

      {formError}

      <CancelableSumbitButton
        testKey='recover-password'
        loading={buttonsDisabled}
        submitText='Recover'
        disabled={buttonsDisabled}
      />
    </Form>
  )
}

export default reduxForm({
  form: 'recoverPassword',
  destroyOnUnmount: true,
})(RecoverPasswordForm)
